export default __webpack_public_path__ + "static/media/11.034cb650.jpg";